import { get } from '@eika-infrastruktur/request';
import type { CreateShareSavingsAccountForChildProcessRules } from '@generated-types';
import { getResourceUrl } from '@react-query/utils';

export const getAccountForChildProcessRules = (): Promise<CreateShareSavingsAccountForChildProcessRules> =>
    get(getResourceUrl('rules'));
